// LeftPosition, TopPosition, Height and Width are decimal(4,2) columns in the
// backend fkReportsConfiguration table, so values must stay within ±99.99 (WA-3715).
export const REPORT_FIELD_MIN = -99.99;
export const REPORT_FIELD_MAX = 99.99;
